import { Box, Colors } from 'basic-ui-lib';
import styled from 'styled-components';

export const FooterMobile = styled(Box)`
  display: flex;
  gap: 16px;
  background-color: ${Colors.neutral.bg[1]};
  position: sticky;
  left: 0;
  bottom: 0;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.15);
  padding: 16px;
  width: 100%;
  z-index: 100;

  button {
    flex: 1;
  }

  @media screen and (min-width: 768px) {
    display: none;
  }

`;